var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whats-app",attrs:{"href":"https://wa.link/iak2wt","target":"_blank"}},[_c('i',{staticClass:"ri-whatsapp-fill animation-icon"})])
}]

export { render, staticRenderFns }